const useRgbToHex = (rgb) => {
    if (rgb.length === 0) {
        rgb = [66, 66, 66]
    }
    let hex = "#"
    for (let i = 0; i < rgb.length; i++) {
        const el = Number(rgb[i]).toFixed(0)
        const numEl = Number(el)
        let subHex = numEl.toString(16).toUpperCase()
        if (subHex === "0") {
        subHex = "00"
        }
        hex += subHex
    }
    return hex
}

export default useRgbToHex